import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { AreaChart } from '@/components/ui/area-chart';

const mockStatsData = [
  { date: '2024-03-14', value: 120 },
  { date: '2024-03-15', value: 145 },
  { date: '2024-03-16', value: 110 },
  { date: '2024-03-17', value: 168 },
  { date: '2024-03-18', value: 189 },
  { date: '2024-03-19', value: 210 },
  { date: '2024-03-20', value: 195 },
];

export default function AgentStats() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">统计</h1>
        <p className="text-muted-foreground mt-1">Agent 使用统计</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">总调用次数</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">1,234</div>
            <p className="text-xs text-muted-foreground mt-1">+12% 较上周</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">Token 消耗</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">56.7K</div>
            <p className="text-xs text-muted-foreground mt-1">+8% 较上周</p>
          </CardContent>
        </Card>

        <Card>
          <CardHeader className="pb-2">
            <CardTitle className="text-sm font-medium text-muted-foreground">
              平均响应时间
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">1.2s</div>
            <p className="text-xs text-muted-foreground mt-1">-5% 较上周</p>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>调用趋势</CardTitle>
        </CardHeader>
        <CardContent>
          <AreaChart data={mockStatsData} height={200} />
        </CardContent>
      </Card>
    </div>
  );
}
